<div class="step-pagination">
    <div class="my-3 d-flex justify-content-between align-items-center">
        <app-components [agenceInscriptionFormControl]="agenceInscriptionFormControl" (onSubmit)="onSubmit()"
        *ngIf="step == 1">
    </app-components>
    </div>
</div>